import type { StateCreator } from "zustand";
import type { Person } from "@/repositories/people/types";

interface PersonSliceState {
  person: Partial<Person> | null;
}

interface PersonSliceActions {
  setPerson: (
    nextPerson:
      | Partial<Person>
      | null
      | ((currentPerson: Partial<Person> | null) => Partial<Person> | null)
  ) => void;
}

export type PersonSlice = PersonSliceState & PersonSliceActions;

export const createPersonSlice: StateCreator<
  PersonSlice,
  [["zustand/devtools", never]],
  [],
  PersonSlice
> = (set) => ({
  person: null,
  setPerson: (nextPerson) =>
    set((state) => {
      const newPerson = typeof nextPerson === "function" ? nextPerson(state.person) : nextPerson;

      return { person: newPerson };
    }),
});
